"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SVGComponent = (props) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", Object.assign({ fill: "none" }, props),
        React.createElement("path", { d: "M7.99935 15.7083C6.72435 15.7083 5.46602 15.3833 4.25768 14.7333L4.19102 14.7L0.682682 15.4916L1.54102 12.125L1.49102 12.05C0.682682 10.7583 0.291016 9.41663 0.291016 7.93329C0.291016 3.71663 3.74935 0.291626 7.99935 0.291626C12.2493 0.291626 15.7077 3.74996 15.7077 7.99996C15.7077 12.25 12.2493 15.7083 7.99935 15.7083ZM4.36602 13.375L4.84102 13.625C5.87435 14.175 6.93268 14.45 7.99935 14.45C11.5577 14.45 14.4577 11.55 14.4577 7.99163C14.4577 4.43329 11.5577 1.54163 7.99935 1.54163C4.44102 1.54163 1.54102 4.40829 1.54102 7.92496C1.54102 9.16663 1.87435 10.2916 2.54935 11.3833L2.88268 11.9083L2.39102 13.8166L4.36602 13.375V13.375Z" }),
        React.createElement("path", { d: "M12.0402 10.0997C12.0402 9.89133 11.8986 9.74966 11.7652 9.68299L10.3069 9.19966C10.0986 9.13299 9.82357 9.19966 9.6819 9.34132L9.0569 9.89966C8.99023 9.96632 8.91523 9.96632 8.84857 9.96632C8.0819 9.89966 6.41523 8.22466 6.2069 7.59966V7.39133L6.69023 6.76632C6.8319 6.55799 6.8319 6.34966 6.7569 6.06632L6.1319 4.67466C5.99023 4.46633 5.8569 4.39966 5.64857 4.39966L5.09023 4.46633C5.02357 4.46633 4.8819 4.53299 4.81523 4.60799C4.39857 5.09132 4.11523 5.64966 4.11523 6.34966C4.11523 7.67466 5.57357 9.19966 6.2069 9.89966L6.41523 10.108L6.5569 10.2497C7.2569 10.808 8.71523 11.9913 10.3152 11.9163C11.0152 11.9163 11.4986 11.433 11.9152 11.008C11.9819 10.9413 12.0569 10.7997 12.0569 10.733V10.108L12.0402 10.0997Z" }))));
exports.default = SVGComponent;
//# sourceMappingURL=whatsapp.js.map